

import type RequestsController from '../requests';
import type { WialonApiSection } from '../requests';

export class Root {
  controller: WialonApiSection;

  constructor(controller: RequestsController) {
    this.controller = controller.getApiSection('');
  }
}
